module.exports = __webpack_public_path__ + "img/banner_itemthr_bigimg.6012d9b8.png";